// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
function use(key, ref) {
  React.useEffect(function () {
    var el = ref.current;
    if (!(el == null)) {
      el.focus();
    }
  }, [key]);
}
export { use };
/* react Not a pure module */